import * as DialogPrimitive from '@radix-ui/react-dialog';

function ModalClose(props: DialogPrimitive.DialogCloseProps) {
  return <DialogPrimitive.DialogClose {...props} />;
}

export { ModalClose };
